<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                © {{ parametro.nombreEntidad }} - Todos los derechos reservados.
            </div>
        </div>
    </div>
</footer>